import React, {
  useRef,
  useEffect,
  useState,
  useCallback,
  memo,
  useMemo,
} from "react";
declare const window: any;

const hexToRGBA = (hex, alpha = 1) => {
  hex = hex.replace("#", "");
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const ordenarVertices = (vertices) => {
  const anguloPolar = (origen, punto) =>
    Math.atan2(punto[1] - origen[1], punto[0] - origen[0]);
  const superiorIzquierdo = vertices.reduce((prev, current) =>
    current[1] < prev[1] || (current[1] === prev[1] && current[0] < prev[0])
      ? current
      : prev
  );
  const verticesOrdenados = vertices
    .filter((vertice) => vertice !== superiorIzquierdo)
    .sort(
      (a, b) =>
        anguloPolar(superiorIzquierdo, a) - anguloPolar(superiorIzquierdo, b)
    );
  return [superiorIzquierdo, ...verticesOrdenados, superiorIzquierdo];
};

const DetailsOverlaysContainer = ({
  setIsSelectedApto,
  isSelectedApto,
  colors,
  theme,
  active,
  frame,
  filter,
  inmueblesUrl,
  originalWidth,
  originalHeight,
  data,
  selectAvailability,
  isSelectedAttribute,
  dragStart,
  setDragStart,
  setIsAnimationAttribute,
  isAnimationAttribute,
}: any) => {
  const svgRef = useRef<SVGSVGElement | null>(null);
  const [inmueblesData, setInmueblesData] = useState([]);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    console.log("aca");
  }, []);

  const fetchData = useCallback(async () => {
    try {
      const response = await fetch(
        `${
          window.hybrid
            ? "./"
            : "https://d1bsymnertnea6.cloudfront.net/"
        }${inmueblesUrl}`
      );
      const data = await response.json();
      console.log(data);
      
      setInmueblesData(data.detail_coord_file);
      setDataLoaded(true);
    } catch (error) {
      console.error("Error al cargar los datos:", error);
    }
  }, [inmueblesUrl]);

  useEffect(() => {
    fetchData();

    const handleResize = () => {
      setScreenWidth(window.innerWidth);
      setScreenHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [fetchData]);

  const processedInmueblesData = useMemo(() => {
    return inmueblesData
      .map((indexFrame: any) => {
        if (indexFrame.frame !== frame) return null;
        return indexFrame.datails
          .map((apto) => {
            if (apto.verts.length > 2) {
              const vertsOrder = ordenarVertices(apto.verts);
              const points = vertsOrder
                .map((coord) => coord.join(","))
                .join(" ");
              const currentApto = data?.property?.find(
                (value) => value.id === apto.id
              );
              const currentAttribute = data?.attributes?.find(
                (value) =>
                  value.name === "Apto tipo" ||
                  value.name === "Locales y Oficinas"
              );

              if (!selectAvailability[currentApto?.availability]) return null;

              if (
                Object.values(isSelectedAttribute).some(
                  (attr: any) =>
                    Object.keys(attr).length > 0 && attr.attribute && attr.value
                )
              ) {
                if (
                  !Object.values(isSelectedAttribute).every((sel: any) =>
                    sel.attribute && sel.value
                      ? currentApto?.values?.some(
                          (ap: any) =>
                            ap.attribute === sel.attribute &&
                            ap.value === sel.value
                        )
                      : true
                  )
                ) {
                  return null;
                }
              }

              return {
                points,
                currentApto,
                currentAttribute,
                vertsOrder,
              };
            } else {
              const vertsOrder = [apto.verts];
              const points = apto.verts;
              const currentApto = data?.property?.find(
                (value) => value.id === apto.id
              );
              const currentAttribute = data?.attributes?.find(
                (value) =>
                  value.name === "Apto tipo" || value.name === "Casas tipo"
              );

              if (!selectAvailability[currentApto?.availability]) return null;

              if (
                Object.values(isSelectedAttribute).some(
                  (attr: any) =>
                    Object.keys(attr).length > 0 && attr.attribute && attr.value
                )
              ) {
                if (
                  !Object.values(isSelectedAttribute).every((sel: any) =>
                    sel.attribute && sel.value
                      ? currentApto?.values?.some(
                          (ap: any) =>
                            ap.attribute === sel.attribute &&
                            ap.value === sel.value
                        )
                      : true
                  )
                ) {
                  return null;
                }
              }

              return {
                points,
                currentApto,
                currentAttribute,
                vertsOrder,
              };
            }
          })
          .filter(Boolean);
      })
      .filter(Boolean);
  }, [inmueblesData, frame, selectAvailability, isSelectedAttribute, data]);

  useEffect(() => {
    const svg = svgRef.current;
    if (!svg || !dataLoaded) return;

    svg.innerHTML = "";

    /* console.log("Frame en componente de overlays ==>  ", frame,
      "    Fecha en componente de overlays ==>  ", new Date(new Date().getTime() - (5 * 60 * 60 * 1000)).toISOString());
 */
    const createSVG = () => {
      const fragment = document.createDocumentFragment();
      processedInmueblesData.forEach((frameData: any) => {
        frameData.forEach(
          ({ points, currentApto, currentAttribute, vertsOrder }) => {
            if (vertsOrder.length > 1) {
              const handleClick = () => {
                currentApto.verts = vertsOrder;
                setIsSelectedApto(currentApto);
              };

              const polygon = document.createElementNS(
                "http://www.w3.org/2000/svg",
                "polygon"
              );
              polygon.setAttribute("points", points);
              polygon.setAttribute("cursor", "pointer");
              polygon.setAttribute("data-type", "INMUEBLE");
              polygon.setAttribute("data-second", currentApto.property);
              polygon.setAttribute(
                "data-value",
                currentApto?.values?.find((e) =>
                  e.hierarchicalLevel !== null
                    ? e.hierarchicalLevel === "Jerarquico #1"
                    : e.type === "Hierarchical"
                ).value
              );
              polygon.setAttribute("cursor", "pointer");
              polygon.setAttribute(
                "pointer-events",
                dragStart ? "none" : "visiblefill"
              );
              polygon.addEventListener("click", handleClick);
              polygon.setAttribute(
                "fill",
                hexToRGBA(
                  data?.disponibilidad &&
                    currentApto?.availability === "DISPONIBLE"
                    ? "#00FA00"
                    : data?.disponibilidad &&
                      currentApto?.availability === "NO DISPONIBLE"
                    ? "#000000"
                    : data?.disponibilidad &&
                      currentApto?.availability === "RESERVADO"
                    ? "#EEA63A"
                    : data?.disponibilidad &&
                      currentApto?.availability === "VENDIDO"
                    ? "#FF0000"
                    : currentAttribute !== undefined
                    ? currentAttribute?.values?.find(
                        (x) =>
                          x.id ===
                          currentApto?.values?.find(
                            (e) => e.attribute === currentAttribute.id
                          )?.IdValue
                      )?.layoutFill
                    : "#000",
                  0.45
                )
              );
              polygon.setAttribute(
                "stroke",
                hexToRGBA(
                  data?.disponibilidad &&
                    currentApto?.availability === "DISPONIBLE"
                    ? "#00FA00"
                    : data?.disponibilidad &&
                      currentApto?.availability === "NO DISPONIBLE"
                    ? "#000000"
                    : data?.disponibilidad &&
                      currentApto?.availability === "RESERVADO"
                    ? "#EEA63A"
                    : data?.disponibilidad &&
                      currentApto?.availability === "VENDIDO"
                    ? "#FF0000"
                    : currentAttribute !== undefined
                    ? currentAttribute?.values?.find(
                        (x) =>
                          x.id ===
                          currentApto?.values?.find(
                            (e) => e.attribute === currentAttribute.id
                          )?.IdValue
                      )?.layoutFill
                    : "#000",
                  0.8
                )
              );
              polygon.setAttribute("stroke-width", "2");

              if (isSelectedApto?.id === currentApto?.id) {
                polygon.classList.add("titilar");
              }

              fragment.appendChild(polygon);
            } else {
              const handleClick = () => {
                currentApto.verts = vertsOrder;
                setIsSelectedApto(currentApto);
              };

              // Crear y añadir el círculo al SVG
              const circle = document.createElementNS(
                "http://www.w3.org/2000/svg",
                "circle"
              );
              circle.setAttribute("cx", points[0].toString());
              circle.setAttribute("cy", points[1].toString());

              const fillColor = hexToRGBA(
                data?.disponibilidad &&
                  currentApto?.availability === "DISPONIBLE"
                  ? "#00FA00"
                  : data?.disponibilidad &&
                    currentApto?.availability === "NO DISPONIBLE"
                  ? "#000000"
                  : data?.disponibilidad &&
                    currentApto?.availability === "RESERVADO"
                  ? "#EEA63A"
                  : data?.disponibilidad &&
                    currentApto?.availability === "VENDIDO"
                  ? "#FF0000"
                  : currentAttribute !== undefined
                  ? currentAttribute?.values?.find(
                      (x) =>
                        x.id ===
                        currentApto?.values?.find(
                          (e) => e.attribute === currentAttribute.id
                        )?.IdValue
                    )?.layoutFill
                  : "#000",
                0.45
              );

              const strokeColor = hexToRGBA(
                data?.disponibilidad &&
                  currentApto?.availability === "DISPONIBLE"
                  ? "#00FA00"
                  : data?.disponibilidad &&
                    currentApto?.availability === "NO DISPONIBLE"
                  ? "#000000"
                  : data?.disponibilidad &&
                    currentApto?.availability === "RESERVADO"
                  ? "#EEA63A"
                  : data?.disponibilidad &&
                    currentApto?.availability === "VENDIDO"
                  ? "#FF0000"
                  : currentAttribute !== undefined
                  ? currentAttribute?.values?.find(
                      (x) =>
                        x.id ===
                        currentApto?.values?.find(
                          (e) => e.attribute === currentAttribute.id
                        )?.IdValue
                    )?.layoutFill
                  : "#000000",
                0.8
              );

              circle.setAttribute("r", (8 * 2).toString());
              circle.setAttribute("stroke", strokeColor);
              circle.setAttribute("fill", fillColor);
              circle.setAttribute("stroke-width", "2");
              //circle.setAttribute("class", `point-am`);

              circle.setAttribute("cursor", "pointer");
              circle.setAttribute("data-type", "INMUEBLE");
              circle.setAttribute("data-second", currentApto.property);
              circle.setAttribute(
                "data-value",
                currentApto?.values?.find((e) =>
                  e.hierarchicalLevel !== null
                    ? e.hierarchicalLevel === "Jerarquico #1"
                    : e.type === "Hierarchical"
                ).value
              );
              circle.setAttribute(
                "pointer-events",
                dragStart ? "none" : "visiblefill"
              );
              circle.addEventListener("click", handleClick);

              // polygon.addEventListener("mousedown", handleMouseDown);
              // polygon.addEventListener("touchstart", handleTouchDown);

              // Añadir clase de animación si isSelectedApto coincide con el inmueble
              if (isSelectedApto?.id === currentApto?.id) {
                circle.classList.add("titilar");
              }

              // Crear el texto "Torre"
              const text = document.createElementNS(
                "http://www.w3.org/2000/svg",
                "text"
              );

              text.setAttribute("x", points[0].toString());
              text.setAttribute("y", `${points[1] + 4}`); // 40 píxeles por encima del círculo
              text.setAttribute("text-anchor", "middle"); // Centrar el texto horizontalmente
              text.setAttribute("fill", colors?.secondary_text); // Cambiar el color del texto a blanco
              text.setAttribute("cursor", "pointer"); // Agregar cursor: pointer al texto
              text.setAttribute("pointer-events", "visiblefill");
              text.setAttribute("font-size", ".75rem");
              text.textContent = currentApto.property;
              text.addEventListener("click", handleClick);

              // Añadir el polígono al SVG

              fragment.appendChild(circle);
              fragment.appendChild(text);
            }
          }
        );
      });

      svg.appendChild(fragment);
      setIsAnimationAttribute(false);
    };

    const timeoutId: any = isAnimationAttribute
      ? setTimeout(createSVG, 600)
      : createSVG();
    return () => {
      if (isAnimationAttribute) {
        clearTimeout(timeoutId); // Limpia el timeout si las dependencias cambian
      }
      //clearTimeout(timeoutGalery); // Limpia el timeout si las dependencias cambian
      svg.innerHTML = ""; // Limpia el SVG de inmediato cuando el efecto se limpia
    };
  }, [
    processedInmueblesData,
    screenWidth,
    screenHeight,
    frame,
    colors,
    filter,
    selectAvailability,
    isSelectedAttribute,
    isSelectedApto,
    dragStart,
    dataLoaded,
  ]);

  return (
    <svg
      ref={svgRef}
      width={screenWidth}
      height={screenHeight}
      preserveAspectRatio="xMidYMid slice"
      viewBox={`0 0 ${originalWidth} ${originalHeight}`}
      style={{
        overflow: "hidden",
        pointerEvents: "none",
        position: "absolute",
        cursor: "pointer",
        top: 0,
      }}
    ></svg>
  );
};

export default memo(DetailsOverlaysContainer);
